export default /^\d{5}(?:[-\s]\d{4})?$/;
